import { genderTranslation, templateIDRentalRequest, simpleFormat, formatValue } from "../../assets/common/common";
import { formatClientName } from "../../libs/formatters";
import { STEP } from "../../store/orderFlow";
import { adMappings, breezyIbisMappings, commonMappings, defaultMappings, STEP_VALUES } from "./rentalrequest.common";
import { format } from 'date-fns';
import _ from 'lodash';

export const getStepInDirection = (currentStep, direction) => {
  const currentIndex = STEP_VALUES.indexOf(currentStep);
  if (currentIndex === -1) return STEP.LOCATION;
  
  const offset = direction === 'forward' ? 1 : -1;
  const newIndex = currentIndex + offset;
  
  return STEP_VALUES[newIndex] ?? STEP.LOCATION;
};

export const getOrderPayload = (steps) => {
  const { organisation, location, service } = steps?.[STEP.LOCATION] || {};
  const product = steps?.[STEP.PRODUCT_CARDS];
  const client = steps?.[STEP.RENTAL_FORM];
  const deliveryInstructions = steps?.[STEP.DELIVERY_FORM];
  const productConfig = steps?.[STEP.PRODUCT_CONFIG];
  const orderData = {
    location,
    service,
    client,
    deliveryInstructions,
    productConfig,
    locations: organisation?.locations,
    organisation: organisation?.label,
    orgId: organisation?.id,
    productId: product?.id,
    productName: product?.name,
    preloadedPDF: {},
  };

  return orderData;
};

export const getPDFBody = (steps, orderId) => {
  const payload = getOrderPayload(steps);
  const client = payload.client;

  const deliveryCheck =
    payload?.deliveryInstructions?.other_delivery_instructions !== ""
      ? `Anders namelijk: ${payload?.deliveryInstructions?.other_delivery_instructions}`
      : payload?.deliveryInstructions?.delivery_instructions;

  // TODO: Refactor in BE, FE doesn't need to do all of these mappings,.
  // BE already has all required data from order with just "getOrderPayload"
  const pdfBody = {
    location: payload?.deliveryInstructions?.department_room_nr,
    locationName: payload?.location?.location_name,
    locationService: payload?.service,
    orderID: orderId,
    creationDate: format(new Date(), 'dd/MM/yyyy'),
    orderDate: format(new Date(), 'dd/MM/yyyy'),
    instruction: deliveryCheck,
    remark: simpleFormat(payload?.productConfig?.productConfigurationAddition),
    fullName: formatClientName(client),
    other_delivery_instructions: simpleFormat(payload?.deliveryInstructions?.other_delivery_instructions),
    gender: genderTranslation(client?.gender || client?.sex),
    birthDate: client?.birthdate,
    hipwidth: simpleFormat(client?.hipWidth),
    upperleglength: simpleFormat(client?.upperlegLength),
    lowerleglength: simpleFormat(client?.lowerlegLength),
    shoulderheight: simpleFormat(client?.shoulderHeight),
    bodyweight: simpleFormat(client?.body_weight),
    templateId: templateIDRentalRequest,
    supplierProductName: payload?.productName,
    ...getConfigVariables(payload.productConfig, payload?.productName),
  };

  return pdfBody;
};

export function flattenObject (obj) {
  let result = {};

  _.forOwn(obj, (value, key) => {
    if (_.isObject(value) && !_.isArray(value)) {
      _.assign(result, flattenObject(value)); // Recursively merge nested objects
    } else {
      result[key] = value;
    }
  });

  return result;
}

// TODO: refactor in BE, so FE can use ENUMs or simply does't need to do these mappings
export const getConfigVariables = (productData, productName) => {
  const config = {};

  const mappings =
    productName === "Breezy Ibis duwrolstoel" ? breezyIbisMappings : defaultMappings;

  // Apply mappings for chosen config properties
  mappings.forEach(({ key, dataKey, label, extra }) => {
    config[key] = formatValue(productData[dataKey], label, extra);
  });

  // Always apply common mappings
  commonMappings.forEach(({ key, dataKey, label }) => {
    config[key] = formatValue(productData[dataKey], label);
  });

  // AD-specific mappings
  if (productName.includes("AD")) {

    adMappings.forEach(({ key, dataKey, label }) => {
      config[key] = formatValue(productData[dataKey], label);
    });

    const toBeUsedWith =
      productData.adTobeUsedWith === "Anders:"
        ? productData.adTobeUsedWith + productData.productConfigurationAddition
        : productData.adTobeUsedWith;
    config.adTobeUsedWith = formatValue(toBeUsedWith, "Bestemd voor:");
  }

  return config;
};
